import { render, staticRenderFns } from "./logData.vue?vue&type=template&id=081b31d1&scoped=true&"
import script from "./logData.vue?vue&type=script&lang=js&"
export * from "./logData.vue?vue&type=script&lang=js&"
import style0 from "./logData.vue?vue&type=style&index=0&id=081b31d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b31d1",
  null
  
)

export default component.exports